import { createContext } from "react"

const defaultState = {
    compactMenu: {
        open: true,
        siderWidth: 56,
    },
    setCompactMenu: () => {}
}

const LayoutContext = createContext(defaultState);

export default LayoutContext